module.exports = __webpack_public_path__ + "static/img/G2.a669bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/G2.png
// module id = mGyL
// module chunks = 1